<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    :scrollable="true"
    icon="fa-address-book"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="addressForm" :labelColumnSize="3">
      <FormRow label="Street Address">
        <FormInputAddressSearch
          placeholder="Address Line 1"
          v-model="address.address1"
          field="address1"
          @updateAddress2="address.address2 = $event"
          @updateSuburb="address.suburb = $event"
          @updatePostcode="address.postcode = $event"
          @updateState="address.state = $event"
          @updateCountry="address.country = $event"
        />
      </FormRow>
      <FormRow label=" "><FormInputText placeholder="Address Line 2" v-model="address.address2" field="address2" /></FormRow>
      <FormRow label="Suburb"><FormInputText placeholder="Suburb" v-model="address.suburb" field="suburb" /></FormRow>
      <FormRow label="Postcode"><FormInputText placeholder="Postcode" v-model="address.postcode" field="postcode" /></FormRow>
      <FormRow label="State"><FormInputText placeholder="State" v-model="address.state" field="state" /></FormRow>
      <FormRow label="Country"><FormInputText placeholder="Country" v-model="address.country" field="country" /></FormRow>
      <FormRow label="Address Labels">
        <FormLabelTag popupName="Address Labels" v-model="address.labelList" labelType="contactAddress" field="labelList" />
      </FormRow>
      
      <FormHorizontalRule />

      <FormRow label="Despatch Tag" helpTip="Limited to a single label, displayed in the production labels / order sheets">
        <FormLabelTag popupName="Delivery Tag" :singleLabelMode="true" v-model="address.deliveryLabelList" labelType="contactAddressDelivery" field="deliveryLabelList" />
      </FormRow>

      <FormRow label="Default Despatch Fees" helpTip="The default fee stock items for the different task types when used for order despatch. If not set, uses contact and system defaults per task type">
        <TaskTypeContactDefaultStock v-model="address.contactTaskTypeDefaultStocks" />
      </FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import TaskTypeContactDefaultStock from '@/modules/tasks/components/taskTypeContactDefaultStock'

export default {
  name: "ContactAddressDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    TaskTypeContactDefaultStock
  },
  props: {
    contactId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      addressId: null,
      address: {},
      addressForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Address' : 'Edit Address'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    }
  },
  methods: {
    show(address) {
      // Reset form
      this.address = {
        address1: '',
        address2: '',
        suburb: '',
        state: '',
        postcode: '',
        country: '',
        labelList: [],
        deliveryLabelList: [],   // JB FIXME: Have to reset this as label control doesn't listen... 
        contactTaskTypeDefaultStocks: []
      }
      this.addressId = 0
      this.addressForm = {}
      this.submitting = false

      if(address != null) {
        this.address = _.cloneDeep(address)
        this.addressId = address.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var addressData = _.cloneDeep(this.$data.address)
      addressData.labelList = addressData.labelList.map(label => label.id)
      addressData.deliveryLabelList = addressData.deliveryLabelList.map(label => label.id)

      if(this.isCreateMode) {
        this.$apiService.contactService.createContactAddress(this.contactId, addressData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.addressForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.contactService.updateContactAddress(this.contactId, this.addressId, addressData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.addressForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>